import './styles/index.css';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createQueryClient, Providers } from './app/providers';
import { createAppRouter } from './app/router';
import { installSessionWatch } from './lib/auth/watch';

const queryClient = createQueryClient();
const router = createAppRouter(queryClient);
installSessionWatch(queryClient, router);

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');
createRoot(root).render(
  <StrictMode>
    <Providers queryClient={queryClient}>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
);
